// @ts-strict-ignore
import type { Experiment } from '@carvana/experiment/SharedTypes';
import * as carStcNewHeroDesign from './buckets/car-stc-cvt-new-hero-design';

export const valuePageClientSideBrowserCookieIdExperiments = {};
export const valuePageClientSideUserIdExperiments = {};

export const valuePageClientSideExperiments = {
  ...valuePageClientSideBrowserCookieIdExperiments,
  ...valuePageClientSideUserIdExperiments
};

export const valuePageServerSideBrowserCookieIdExperiments = {};
export const valuePageServerSideUserIdExperiments = {}; // NOTE: Not currently wired up in the getExperiments middleware

export const valuePageServerSideExperiments = {
  ...valuePageServerSideBrowserCookieIdExperiments,
  ...valuePageServerSideUserIdExperiments
};

export const valuePageBrowserCookieIdExperiments = {
  ...valuePageClientSideBrowserCookieIdExperiments,
  ...valuePageServerSideBrowserCookieIdExperiments
};

export const valuePageUserIdExperiments = {
  ...valuePageClientSideUserIdExperiments,
  ...valuePageServerSideUserIdExperiments
};

export const valuePageExperimentList = {
  ...valuePageClientSideBrowserCookieIdExperiments,
  ...valuePageClientSideUserIdExperiments,
  ...valuePageServerSideBrowserCookieIdExperiments,
  ...valuePageServerSideUserIdExperiments
};

export const vinBasedServerSideExperimentList = {};

export const marketingPageClientSideBrowserCookieIdExperiments = {};
export const marketingPageClientSideUserIdExperiments = {};

export const marketingPageServerSideBrowserCookieIdExperiments = {
  [carStcNewHeroDesign.NAME]: {}
};

export const marketingPageBrowserCookieIdExperiments = {
  ...marketingPageClientSideBrowserCookieIdExperiments,
  ...marketingPageServerSideBrowserCookieIdExperiments
};

export const marketingPageExperimentList = {
  ...marketingPageClientSideBrowserCookieIdExperiments,
  ...marketingPageServerSideBrowserCookieIdExperiments
};

export const browserCookieIdExperiments = {
  ...valuePageBrowserCookieIdExperiments,
  ...marketingPageBrowserCookieIdExperiments
};

export const clientSideUserIdExperiments = {
  ...valuePageClientSideUserIdExperiments,
  ...marketingPageClientSideUserIdExperiments
};

export const getExperimentList = (
  page: 'marketing' | 'value' | 'vin_based',
  conditions: { [name: string]: boolean } = {}
) => {
  const defaultSet =
    {
      marketing: marketingPageExperimentList,
      value: valuePageExperimentList,
      vin_based: vinBasedServerSideExperimentList
    }[page] || valuePageExperimentList;

  const filteredSet = Object.keys(defaultSet).reduce((acc, experimentName) => {
    if (conditions[experimentName] || conditions[experimentName] === undefined) {
      acc[experimentName] = defaultSet[experimentName];
    }

    return acc;
  }, {});

  return filteredSet;
};

export const environment = process.env.DEPLOY_ENV;

const commonEnvironmentMapping = {
  dev: 'development',
  test: 'test',
  prod: 'production'
};

export const commonEnvironment = commonEnvironmentMapping[environment];

export const settings = {
  cacheMinutes: 15,
  environment: commonEnvironment
};

export type Experiments = Record<
  keyof (typeof valuePageExperimentList &
    typeof marketingPageExperimentList &
    typeof vinBasedServerSideExperimentList),
  Experiment
>;
